import { create, tsx } from '@dojo/framework/core/vdom';

import { Head } from '../../widgets/Head';
import { HeroBackground } from '../../widgets/HeroBackground';
import { Section } from '../../widgets/Section';
import { ContentWrapper } from '../../widgets/ContentWrapper';

import BlogList from './BlogList';
import NewsLetter from '../newsletter/NewsLetter';

interface BlogsProperties {
	termOrSlug?: never;
	type?: never;
	page: number;
}

interface SearchBlogsProperties {
	termOrSlug: string;
	type: 'category' | 'series' | 'search';
	page?: never;
}

interface LatestBlogsProperties {
	termOrSlug?: never;
	type: 'latest';
	page?: never;
}

const factory = create().properties<
	BlogsProperties | SearchBlogsProperties | LatestBlogsProperties
>();

export const Blogs = factory(function Blogs({ properties }) {
	return (
		<div>
			<Head
				title="Development and JavaScript Blog | SitePen"
				description="The SitePen blog gives educational tips for solving big business problems and achieving technical objectives."
			/>
			<HeroBackground background="level2BluePurple" />
			<Section>
				<ContentWrapper>
					<BlogList {...properties()} />
				</ContentWrapper>
			</Section>
			<Section type="trailing" shaded>
				<ContentWrapper>
					<NewsLetter />
				</ContentWrapper>
			</Section>
		</div>
	);
});
